import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="border-top-line">
        <div className="container mx-auto py-20">
          <div className="grid grid-cols-1 lg:justify-items-center lg:grid-cols-3">
            <div className="px-8 lg:px-20">
              <div className="py-2">
                <h3 className="font-bold text-blue text-lg mb-2">{t('office')}</h3>
                <div className="py-2">
                  <p className="font-semibold text-black text-base mb-2">{t('headOffice')} (Surabaya)</p>
                  <p>
                    IdeaHub Voza Tower, lantai 20
                    Jl. Mayjen HR. Muhammad No.31 Sukomanunggal, Surabaya
                    Jawa Timur, 60189
                  </p>
                </div>
                <div className="py-3">
                  <p className="font-semibold text-black text-base mb-2">{t('branchOffice')} (Jakarta)</p>
                  <p>
                    GoWork Sampoerna Strategic
                    Square, North Tower Lantai 12
                    Jl. Jend. Sudirman Kav.45 Karet Semanggi Setiabudi, Jakarta Selatan, 12930
                  </p>
                </div>
              </div>
              <div className="block lg:hidden">
                <div className="py-2">
                  <h3 className="font-bold text-lg mb-2 text-blue">{t('contactUs')}</h3>
                  {/* <h4 className="text-sm py-2">
                  <span className="font-bold">Office</span>
                  <br />
                  (031) 9920 6672
                </h4> */}
                  <h4 className="text-sm py-2">
                    <span className="font-bold">Whatsapp</span>
                    <br />
                    <p>
                      <a href="https://api.whatsapp.com/send?phone=6285163106672" className="cursor-pointer" target="_blank" rel="noreferrer">
                        +62-851-6310-6672
                      </a>
                    </p>
                  </h4>
                  <h4 className="text-sm py-2">
                    <span className="font-bold">Mail</span>
                    <br />
                    <a className="text-gray" href="mailto:hello@komunal.co.id">hello@komunal.co.id</a>
                  </h4>
                </div>
              </div>
            </div>
            <div className="hidden lg:block">
              <div className="py-2">
                <h3 className="font-bold text-lg text-blue mb-2">{t('contactUs')}</h3>
                <h4 className="text-sm py-2">
                  <span>Mail</span>
                  <br />
                  <div className="flex items-center">
                    <StaticImage
                      src="../../images/mail.png"
                      objectFit="contain"
                      className="w-5 mr-1"
                      alt="mail-img"
                      placeholder="none"
                    />
                    <a className="text-gray" href="mailto:hello@komunal.co.id">hello@komunal.co.id</a>
                  </div>
                </h4>
                <h4 className="text-sm py-2 mt-3">
                  <span>Whatsapp</span>
                  <br />
                  <div className="flex items-center">
                    <StaticImage
                      src="../../images/whatsapp.png"
                      objectFit="contain"
                      className="w-5 mr-1"
                      alt="whatsapp-img"
                      placeholder="none"
                    />
                    <a className="text-gray" href="https://api.whatsapp.com/send?phone=6285163106672">+62 851-6310-6672</a>
                  </div>
                </h4>
              </div>
              <div className="py-5">
                <h3 className="font-medium text-lg mb-2 text-blue">{t('followUs')}</h3>
                <div className="flex justify-between w-60 my-3">
                  <a href="https://www.youtube.com/@KomunalIndonesia" target="_blank" rel="noreferrer">
                    <StaticImage
                      src="../../images/youtube.png"
                      alt="youtube-logo"
                      objectFit="contain"
                      placeholder="none"
                      className="w-12"
                    />
                  </a>
                  <a href="https://www.linkedin.com/company/komunal-id" target="_blank" rel="noreferrer">
                    <StaticImage
                      src="../../images/linkedin-footer.png"
                      alt="linkedin-logo"
                      objectFit="contain"
                      placeholder="none"
                      className="w-12"
                    />
                  </a>
                  <a href="https://twitter.com/komunal_id" target="_blank" rel="noreferrer">
                    <StaticImage
                      src="../../images/twitter.png"
                      alt="telegram-logo"
                      objectFit="contain"
                      placeholder="none"
                      className="w-12"
                    />
                  </a>
                  <a href="https://www.instagram.com/komunal.id/" target="_blank" rel="noreferrer">
                    <StaticImage
                      src="../../images/instagram.png"
                      alt="instagram-logo"
                      objectFit="contain"
                      placeholder="none"
                      className="w-12"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="px-8 lg:px-0">
              <div className="py-2">
                <h3 className="font-bold text-lg text-blue mb-4">{t('registeredIn')}</h3>
                <div className="flex">
                  <StaticImage
                    src="../../images/kominfo-logo.png"
                    alt="kominfo-logo"
                    objectFit="contain"
                    placeholder="none"
                    className="w-12"
                  />
                  <StaticImage
                    src="../../images/fintech-logo.png"
                    alt="fintech-logo"
                    objectFit="contain"
                    placeholder="none"
                    className="lg:ml-3 w-20"
                  />
                </div>
              </div>
              <div className="py-6">
                <h3 className="font-bold text-lg text-blue mb-4">{t('certified')}</h3>
                <StaticImage
                  src="../../images/system-certified.png"
                  alt="system-img"
                  objectFit="contain"
                  placeholder="none"
                  className="w-16"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
